export const PACKER_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Shipping Dashboard', href: '/shipping/dashboard', icon: 'cilRoute' },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Scanner', href: '/shipping/scanner', icon: 'cilScan' },
  { slug: 'link', name: 'Packing Batches', href: '/packingBatches', icon: 'cilPackage' },
  { slug: 'link', name: 'Barcodes', href: '/barcodes', icon: 'cilBarcode' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
